import application from 'application/application';

const controller = 'DefaultAccountNotificationsController';

application.controller(controller, [
	'$rootScope',
	'$scope',
	'$http',
	'$state',
	'$stateParams',
	'API',
	'$timeout',
	'helper',
	'notification',
	'authentication',
	'environment',
	'googleAPI',
	'integracaoGoogleCalendar',
	(
		$rootScope,
		$scope,
		$http,
		$state,
		$stateParams,
		API,
		$timeout,
		helper,
		notification,
		authentication,
		environment,
		googleAPI,
		integracaoGoogleCalendar
	) => {
		$scope.permissions = helper.responseStore();

		//Validação de Email Notificação
		$scope.validateEmail = /(^[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)(\s?\;\s?[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)*?$/i;

		$scope.placeHolderText = 'Adicione mais emails separando por ";"';

		$scope.messagefourTimes =
			'<div class="font-weight-normal" style="width: 105px;"> <br/> <strong>Períodos de envio:</strong> <br/> <br/> <strong>1°</strong> - 7h às 8h <strong> <br/> 2°</strong> - 10h às 11h <strong> <br/> 3°</strong> - 13h às 14h <strong> <br/> 4°</strong> - 16h às 17h</div>';

		$scope.messagefourTimes2 =
			'<div class="font-weight-normal" style="width: 100px;"> <br/> <strong>Período de envio:</strong> <br/> <br/> Dás 16h às 17h</div>';

		const defautEmptyEmail = {
			email: ''
		};

		$scope.selectIntegra = true;
		$scope.selectQuantidade = false;

		$scope.loadingRecordGroups = false;

		$scope.publishEmail = [];

		$scope.saveEmail = [];

		$scope.errorGroup = true;

		$scope.printing = false;

		$scope.notPublicEmailOption2 = -24;

		$scope.publicEmailOption2 = 'QUANTIDADE';

		$scope.procEmailOption2 = 'PROCCESS_QUANTIDADE';

		$scope.intimacoesEmailOption2 = 'INTIMACOES_QUANTIDADE';

		$scope.currentPage = null;

		/** Verifica se tem grupo selecionado no storage */
		$scope.groupSelect = localStorage.getItem('__groupSelected__');

		/** Pega os dados do grupo selecionado no storage */
		$scope.groupUserData = JSON.parse(
			localStorage.getItem('__groupUserData__')
		);

		/** Pega o nome do usuario cliente do storage */
		$scope.userName = authentication.getUserData('nome');

		/** Pega o id do cliente do storage */
		const idCliente = parseInt(authentication.getUserData('idCliente'));

		/** Pega o id do usuario cliente do storage */
		const userClient = authentication.getUserData('idUsuarioCliente');

		$scope.groups = helper.responseStore();

		$scope.currentTab = 'nav-notificacoes';

		$scope.storeCurrentTabOnLocalStorage = tab => {
			$scope.currentTab = tab;

			const now = new Date();
			const tabInfo = {
				tab: tab,
				moment: now
			};

			localStorage.setItem('__hasTabMemory__', JSON.stringify(tabInfo));
		};

		$scope.readCurrentTabFromLocalStorage = defaultValue => {
			const timeLimit = new Date(new Date().getTime() - 300000); // Coloca um valor de 5 minutos atrás, que é o limite de informação que ele tolera para tentar atualizar
			const hasTabMemory = localStorage.getItem('__hasTabMemory__');

			if (hasTabMemory) {
				const localStorageItem = JSON.parse(hasTabMemory);
				const { tab, moment } = localStorageItem;

				if (new Date(moment).getTime() - new Date(timeLimit).getTime() > 0) {
					$scope.currentTab = tab;

					return;
				}
			}

			$scope.currentTab = defaultValue;
		};

		$scope.readCurrentTabFromLocalStorage('nav-notificacoes');

		$scope.checkClientGroup = async () => {
			if ($scope.groupSelected != 'true') {
				$scope.errorGroup = false;

				return;
			}

			await $http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields(['possuiGrupo']),
					IDs: idCliente
				}
			}).then(async response => {
				$rootScope.haveGroup = response.data.itens[0].possuiGrupo;

				if (response.data.itens[0].possuiGrupo) {
					await $scope.findGroup($scope.groups);
				} else {
					$rootScope.haveGroup = false;

					localStorage.setItem('__hasGroup__', $rootScope.haveGroup);
					localStorage.removeItem('__groupUserData__');
					localStorage.removeItem('__groupSelected__');

					location.reload();
				}
			});
		};

		$scope.checkClientGroup();

		/** Busca os grupo que o usuário selecionou no storage
		 *  Verifica se ele está no grupo e se é Administrador
		 */
		$scope.findGroup = responseStore => {
			$http({
				...helper.http(API.groupUsers, 'GET'),
				params: {
					...helper.httpFields([
						'idGrupo',
						'nomeGrupo',
						'idCliente',
						'idSituacaoGrupo',
						'situacaoGrupo',
						'listaUsuariosGrupo.idUsuarioXGrupo',
						'listaUsuariosGrupo.idUsuarioCliente',
						'listaUsuariosGrupo.nomeUsuario',
						'listaUsuariosGrupo.administrador',
						'listaUsuariosGrupo.ativo'
					]),
					IdsGrupoUsuarios: $scope.groupUserData.idGrupo,
					IdsClientes: [idCliente],
					IdsSituacaoGrupoUsuario: [-1]
				}
			})
				.then(response => {
					if (!response.data.itens.length > 0) {
						// Grupo não encontrado.

						return;
					}

					if (!response.data.itens[0].listaUsuariosGrupo.length > 0) {
						// Grupo não possui usuários.

						return;
					}

					let group = response.data.itens[0];

					let userGroup = group.listaUsuariosGrupo.filter(
						userGroup =>
							parseInt(userGroup.idUsuarioCliente) === parseInt(userClient) &&
							userGroup.administrador &&
							userGroup.ativo
					);

					if (!userGroup.length > 0) {
						// É necessário pertencer ao grupo e possuir privilégios de administrador.

						return;
					}

					$scope.errorGroup = false;

					responseStore.setItems(group);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.userData = JSON.parse(
			localStorage.getItem('__authenticationUserData__')
		);

		/** Pega o id do produto do usuario cliente do storage */
		const product = authentication.getUserData('idProdutoAdvise');

		/** Novo emails. */
		$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);

		/** Armazenamento de resposta. */
		$scope.emails = helper
			.responseStore()

			.setItemsPerPage(-1);

		$scope.emailOptions = helper
			.responseStore()

			.setItemsPerPage(-1);

		$scope.userEmailOptions = helper
			.responseStore()

			.setItemsPerPage(-1);

		/** Carregar emails. */
		const recordEmails = (responseStore, callback = () => {}) => {
			let params = {
				...helper.httpFields(['*']),
				paginaAtual: responseStore.getCurrentPage(),
				registrosPorPagina: responseStore.getItemsPerPage(),
				...responseStore.getFilters(),
				flAtivo: true
			};

			if ($scope.groupSelect == 'true') {
				params.idGrupo = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.notificationsEmails, 'GET'),
				params: params
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					callback();
				})

				.finally(() => responseStore.setReady(true));
		};

		recordEmails($scope.emails);

		const normalizeEmail = email =>
			typeof email === 'string' ? email.trim().toLowerCase() : '';
		const validateSingleEmail = email =>
			/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
		const splitEmails = emails =>
			(typeof emails === 'string' ? emails : '')
				.split(';')
				.map(email => email.trim())
				.filter(email => email.length > 0);

		const getRegisteredEmails = () =>
			$scope.emails && typeof $scope.emails.getItems === 'function'
				? $scope.emails.getItems().map(value => normalizeEmail(value.email))
				: [];

		const getEmailConflictData = (emails = []) => {
			const existingEmails = new Set(
				$scope.publishEmail.map(value => normalizeEmail(value.email))
			);
			const registeredEmails = new Set(getRegisteredEmails());
			const newEmails = [];
			const typedEmails = new Set();
			let hasDuplicateEmail = false;
			let hasAlreadyRegisteredEmail = false;

			emails.forEach(email => {
				const normalizedEmail = normalizeEmail(email);
				const alreadyRegistered = registeredEmails.has(normalizedEmail);
				const alreadyOnList = existingEmails.has(normalizedEmail);
				const duplicatedOnCurrentInput = typedEmails.has(normalizedEmail);

				if (alreadyRegistered) {
					hasAlreadyRegisteredEmail = true;

					return;
				}

				if (alreadyOnList || duplicatedOnCurrentInput) {
					hasDuplicateEmail = true;

					return;
				}

				typedEmails.add(normalizedEmail);
				newEmails.push({ email });
			});

			return {
				hasDuplicateEmail,
				hasAlreadyRegisteredEmail,
				newEmails
			};
		};


		$scope.emailConflict = false;
		$scope.emailInvalidFormat = false;

		$scope.listAddEmail = emails => {
			if (!emails) return;

			$scope.emailConflict = false;
			$scope.emailInvalidFormat = false;

			const parsedEmails = splitEmails(emails);
			const hasInvalidEmail = parsedEmails.some(
				email => !validateSingleEmail(email)
			);

			if (hasInvalidEmail) {
				$scope.emailInvalidFormat = true;
				notification.danger('Email inválido!');

				return;
			}

			const {
				hasDuplicateEmail,
				hasAlreadyRegisteredEmail,
				newEmails
			} = getEmailConflictData(parsedEmails);

			if (hasAlreadyRegisteredEmail) {
				$scope.emailConflict = true;
				notification.danger(
					'E-mail já cadastrado para receber notificação'
				);
			} else if (hasDuplicateEmail) {
				$scope.emailConflict = true;
				notification.danger('Email já existe na lista para cadastro!');
			}

			newEmails.forEach(email => $scope.publishEmail.push(email));

			$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);
			$scope.emailConflict = false;
			$scope.emailInvalidFormat = false;

			$scope.formatedEmail($scope.publishEmail);
		};

		$scope.listRemoveEmail = email => {
			$scope.publishEmail = $scope.publishEmail.filter(
				value => value.email != email
			);
		};

		$scope.deleteEmail = (id, id2, close) => {
			const el1 = document.getElementById(id);
			const el2 = document.getElementById(id2);

			if (!close) {
				el1.classList.add('active');
				el2.classList.add('hidden');
			} else {
				el1.classList.remove('active');
				el2.classList.remove('hidden');
			}
		};

		$scope.formatedEmail = emails => {
			var email = [];

			emails.forEach(value => email.push(value.email));

			if (emails.length > 0) email = email.join(';');

			$scope.saveEmail.email = email;
		};

		$scope.createEmails = (responseStore, items, reset) => {
			$scope.printing = true;

			var email = [];

			$scope.publishEmail.forEach(value => email.push(value.email));

			if (email.length > 0) email = email.join(';');

			$scope.saveEmail.email = email;

			let params = [];

			params.push({
				email: $scope.saveEmail.email
			});

			if ($scope.groupSelect == 'true')
				params[0].idGrupoUsuarios = $scope.groupUserData.idGrupo;

			$http({
				...helper.http(API.notificationsEmails, 'POST'),
				data: {
					itens: params
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Email cadastrado!');
					},
					error(response, notify) {
						const responseData =
							response && response.data ? response.data : {};
						const responseStatus = responseData.status || {};
						const responseErrors = Array.isArray(responseStatus.erros)
							? responseStatus.erros
							: [];
						const apiErrorDetailMessage =
							responseErrors[0] && responseErrors[0].mensagem
								? responseErrors[0].mensagem
								: '';
						const apiErrorMessage =
							apiErrorDetailMessage ||
							responseStatus.mensagem ||
							responseData.mensagem ||
							responseData.message;

						const emailValue =
							$scope.saveEmail && $scope.saveEmail.email
								? $scope.saveEmail.email.trim()
								: '';

						const hasInvalidEmail =
							!emailValue || !$scope.validateEmail.test(emailValue);

						if (response.status == 400) {
							if (apiErrorMessage) {
								const normalizedMessage = String(
									apiErrorMessage
								).toLowerCase();

								if (
									normalizedMessage.includes('inválid') ||
									normalizedMessage.includes('inval')
								) {
									notify.danger('Email inválido!');

									return;
								}

								if (
									normalizedMessage.includes('cadastrad') ||
									normalizedMessage.includes('exist')
								) {
									notify.danger('Email já cadastrado!');

									return;
								}

								notify.danger(
									hasInvalidEmail ? 'Email inválido!' : apiErrorMessage
								);

								return;
							}

							notify.danger(
								hasInvalidEmail ? 'Email inválido!' : 'Email já cadastrado!'
							);

							return;
						}

						notify.danger(apiErrorMessage || 'Erro ao adicionar email!');
					}
				}
			})
				.then(
					response => {
						responseStore.pushItems(response.data.itens);

						$('.modal').modal('hide');

						$scope.publishEmail = [];

						$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);
					},
					function(error) {
						return error;
					}
				)

				.finally(() => {
					typeof reset === 'function' && reset();
					$scope.printing = false;
				});
		};

		$scope.cloneModal = () => {
			$('.modal').modal('hide');

			$scope.publishEmail = [];
			$scope.emailConflict = false;
			$scope.emailInvalidFormat = false;
		};

		$scope.openModal = id => {
			if (id == 'modalCreateNotificationEmail') {
				setTimeout(() => {
					$('#inputCreateEmail').focus();
				}, 600);
			}

			$(`#${id}`).modal('show');
		};

		$scope.openDeleteModalEmails = (emails, email) => {
			$scope.emailsModal = emails;

			$scope.emailModal = email;

			$scope.openModal('modalDeleteEmail');
		};

		$scope.closeModal = id => $(`#${id}`).modal('hide');

		$scope.existPublications = false;
		$scope.existProcesses = false;
		$scope.existIntimacoes = false;

		$scope.recordPermissions = () => {
			$scope.permissions.setReady(false);

			$http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields([
						'nomeServico',
						'idFuncionalidade',
						'idServico'
					]),
					registrosPorPagina: -1,
					ativo: true
				}
			})
				.then(response => {
					$scope.existPublications = response.data.itens.some(
						item => item.idServico === -1
					);
					$scope.existProcesses = response.data.itens.some(
						item => item.idServico === -2
					);
					$scope.existIntimacoes = response.data.itens.some(
						item => item.idServico === -15 && item.idFuncionalidade === -72
					);

					$scope.permissions.setItems(response.data.itens);
				})
				.finally(() => $scope.permissions.setReady(true));
		};

		$scope.recordPermissions();

		/** Retorna as opçoes de notificação cadastradas no usuario-cliente. */

		$scope.recordUserOptions = responseStore => {
			$http({
				...helper.http(API.actionUserEvents, 'GET'),
				params: {
					...helper.httpFields([
						'ativo',
						'id',
						'idUsuarioCliente',
						'idRegraAcaoEvento',
						'idProdutoAdviseXAcaoEvento',
						'descricaoRegraAcaoEvento',
						'nomeProdutoAdviseXAcaoEvento'
					])
				}
			})
				.then(response => {
					let userOptions = response.data.itens[0];

					var arrTest = $scope.emailOptions.getItems().map(item => ({
						...item,
						regrasAcaoEvento: item.regrasAcaoEvento.map(rule => ({
							descricaoRegraAcaoEvento: rule.descricao,
							id: userOptions.find(item => item.idRegraAcaoEvento == rule.id)
								? userOptions.find(item => item.idRegraAcaoEvento == rule.id).id
								: rule.id,
							idRegraAcaoEvento: rule.id,
							ativo: userOptions.find(item => item.idRegraAcaoEvento == rule.id)
								? userOptions.find(item => item.idRegraAcaoEvento == rule.id)
										.ativo
								: false,
							idUsuarioCliente: userClient,
							update: userOptions.find(
								item => item.idRegraAcaoEvento == rule.id
							)
								? true
								: false
						}))
					}));

					responseStore.setItems(arrTest);
				})

				.finally(() => {
					responseStore.setReady(true);
				});
		};

		/** Retorna todas as opções de notificações de emails disponíveis*/

		$scope.recordEmailOptions = responseStore => {
			$http({
				...helper.http(API.actionEvents, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			})
				.then(response => {
					let arrItems = [];

					response.data.itens[0].map(item => {
						if (
							item.acoesEvento[0].produtosAdviseAcaoEvento.some(
								item =>
									item.idProdutoAdvise == product &&
									item.opcaoPorUsuarioCliente == true
							)
						) {
							let newItem = {
								id: item.acoesEvento[0].id,
								idTipoAcaoEvento: item.acoesEvento[0].idTipoAcaoEvento,
								descricao: item.acoesEvento[0].descricao,
								regrasAcaoEvento: item.acoesEvento[0].regrasAcaoEvento
							};

							arrItems.push(newItem);
						}
					});

					responseStore.setItems(arrItems);
				})
				.finally(() => {
					responseStore.setReady(true);
					$scope.recordUserOptions($scope.userEmailOptions);
				});
		};

		$scope.recordEmailOptions($scope.emailOptions);

		/** Cria opçoes de notificação. */

		$scope.createEmailOptions = options => {
			$http({
				...helper.http(API.actionUserEvents, 'POST'),
				data: {
					itens: options
				}
			}).then(response => response.data.itens);
		};

		/** Atualiza opçoes de notificação. */

		$scope.updateEmailOptions = options => {
			$http({
				...helper.http(API.actionUserEvents, 'PUT'),
				data: {
					itens: options
				}
			}).then(response => response.data.itens);
		};

		$scope.updateOptions = options => {
			let updateOpt = [];
			let addOpt = [];

			options.getItems().map(item =>
				item.regrasAcaoEvento.map(rule => {
					if (rule.descricaoRegraAcaoEvento.length > 0)
						rule.update == true
							? updateOpt.push(rule)
							: rule.ativo == true
							? addOpt.push(rule)
							: null;
				})
			);

			if (updateOpt.length > 0) $scope.updateEmailOptions(updateOpt);
			if (addOpt.length > 0) $scope.createEmailOptions(addOpt);
		};

		$scope.onCheck = op => {
			let a = $scope.userEmailOptions
				.getItems()
				.find(item =>
					item.regrasAcaoEvento.find(
						item => item.idRegraAcaoEvento == op.idRegraAcaoEvento
					)
				);

			if (a.regrasAcaoEvento.length > 1)
				a.regrasAcaoEvento.map(item =>
					item.idRegraAcaoEvento !== op.idRegraAcaoEvento
						? (item.ativo = false)
						: (item.ativo = op.ativo)
				);
		};
		//a
		/** Excluir emails. */
		$scope.confirmDeleteEmail = (responseStore, item) => {
			$scope.printing = true;

			let items = [item];

			responseStore.setItemsAsBusy(item);

			let data = {
				iDs: items.map(value => value.id)
			};

			$http({
				...helper.http(API.notificationsEmails, 'disable'),
				method: 'PUT',
				data: data,
				messageOverride: {
					success(response, notify) {
						notify.success('Email excluído!');
					}
				}
			})
				.then(
					response => responseStore.removeItems(response.data.itens, 'id'),
					() => responseStore.rowbackItems(items)
				)

				.finally(() => {
					responseStore.setItemsAsNotBusy(items);
					$scope.printing = false;
				});

			$('.modal').modal('hide');
		};

		$scope.idRegraAcaoEvento = null;

		$scope.sendNotificationAction = () => {
			$scope.printingNot = true;

			let params = [];

			$scope.idRegraAcaoEvento = null;

			const element = document.getElementById('send-mov-notification');

			const itemChecked = element.checked;

			$scope.publicEmail = itemChecked;

			if (itemChecked) {
				$scope.publicEmailOption = 'QUANTIDADE';
				params.push({
					ativo: true,
					idRegraAcaoEvento: -1,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -23,
					idCliente: $scope.userData.idCliente
				});
				$scope.bIntegra = false;
				$scope.bAviso = true;
				updateNotificationAction(params);
			} else {
				$scope.publicEmailOption = 'QUANTIDADE';
				params.push({
					ativo: false,
					idRegraAcaoEvento: -1,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -23,
					idCliente: $scope.userData.idCliente
				});
				updateNotificationAction(params);
			}

			$timeout(() => {
				$scope.printingNot = false;
			}, 1000);
		};

		$scope.sendNotIntimacoesNotificationAction = () => {
			$scope.printingNotIntimacoes = true;

			const element = document.getElementById(
				'send-not-intimacoes-notification'
			);

			const itemChecked = element.checked;

			$scope.notIntimacoesEmail = itemChecked;

			let params = [
				{
					ativo: itemChecked,
					idRegraAcaoEvento: -39,
					idCliente: $scope.userData.idCliente
				}
			];

			updateNotificationAction(params);

			$timeout(() => {
				$scope.printingNotIntimacoes = false;
			}, 1000);
		};

		$scope.sendIntimacoesNotificationAction = () => {
			$scope.printingIntimacoes = true;

			const element = document.getElementById('send-intimacoes-notification');

			const itemChecked = element.checked;

			$scope.intimacoesEmail = itemChecked;

			let params = [];

			if (itemChecked) {
				$scope.intimacoesEmailOption = 'INTIMACOES_QUANTIDADE';
				params.push({
					ativo: true,
					idRegraAcaoEvento: -37,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -38,
					idCliente: $scope.userData.idCliente
				});
				$scope.bIntegra = false;
				$scope.bAviso = true;
				updateNotificationAction(params);
			} else {
				$scope.intimacoesEmailOption = 'INTIMACOES_QUANTIDADE';
				params.push({
					ativo: false,
					idRegraAcaoEvento: -37,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -38,
					idCliente: $scope.userData.idCliente
				});
				updateNotificationAction(params);
			}

			$timeout(() => {
				$scope.printingIntimacoes = false;
			}, 1000);
		};

		$scope.sendIntimacoesNotification = value => {
			$scope.intimacoesEmailOption = value;

			let params = [
				{
					ativo: value === 'INTIMACOES_QUANTIDADE' ? true : false,
					idRegraAcaoEvento: -37,
					idCliente: $scope.userData.idCliente
				},
				{
					ativo: value === 'INTIMACOES_INTEGRA' ? true : false,
					idRegraAcaoEvento: -38,
					idCliente: $scope.userData.idCliente
				}
			];

			updateNotificationAction(params);
		};

		$scope.sendNotNotificationAction = value => {
			$scope.printingNoNot = true;

			const element = document.getElementById('send-mov-not-notification');

			const itemChecked = element.checked;

			$scope.notPublicEmail = itemChecked;

			if (!value) {
				$scope.notPublicEmailOption = -24;
			} else {
				$scope.notPublicEmailOption = value;
			}

			let params = [
				{
					ativo:
						itemChecked && $scope.notPublicEmailOption === -24 ? true : false,
					idRegraAcaoEvento: -24,
					idCliente: $scope.userData.idCliente
				},
				{
					ativo:
						itemChecked && $scope.notPublicEmailOption === -25 ? true : false,
					idRegraAcaoEvento: -25,
					idCliente: $scope.userData.idCliente
				}
			];

			updateNotificationAction(params);

			$timeout(() => {
				$scope.printingNoNot = false;
			}, 1000);
		};

		$scope.sendProcNotificationAction = () => {
			$scope.printingProcNot = true;

			let params = [];

			$scope.idRegraAcaoEvento = null;

			const element = document.getElementById('send-mov-proc-notification');

			const itemChecked = element.checked;

			$scope.procEmail = itemChecked;

			if (itemChecked) {
				params.push({
					ativo: true,
					idRegraAcaoEvento: -3,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -31,
					idCliente: $scope.userData.idCliente
				});
				$scope.procEmailOption = 'PROCCESS_QUANTIDADE';
				updateNotificationAction(params);
			} else {
				$scope.procEmailOption = 'PROCCESS_QUANTIDADE';
				params.push({
					ativo: false,
					idRegraAcaoEvento: -3,
					idCliente: $scope.userData.idCliente
				});
				params.push({
					ativo: false,
					idRegraAcaoEvento: -31,
					idCliente: $scope.userData.idCliente
				});
				updateNotificationAction(params);
			}

			$timeout(() => {
				$scope.printingProcNot = false;
			}, 1000);
		};

		const updateNotificationAction = params => {
			if ($scope.groupSelect != 'true') {
				params.map(
					item => (item.idUsuarioCliente = $scope.userData.idUsuarioCliente)
				);
			} else {
				params.map(
					item => (item.IdGrupoUsuarios = $scope.groupUserData.idGrupo)
				);
			}

			$http({
				...helper.http(API.actionEventClientUser, 'PUT'),
				method: 'PUT',
				data: {
					itens: params
				},
				messageOverride: {
					success() {}
				}
			});
		};

		$scope.updateRadiosOptions = () => {
			if ($scope.sendNotification) {
				if ($scope.tipoIntegra == true) {
					document.getElementById('radio-integra').checked = true;
				} else {
					document.getElementById('radio-quantidade').checked = true;
				}
			}

			if ($scope.sendProcNotification) {
				if ($scope.processNew == true) {
					document.getElementById('radio-process-new').checked = true;
				} else {
					document.getElementById('radio-process-quantidade').checked = true;
				}
			}
		};

		$scope.setNotification = type => {
			let params = [];

			$scope.bIntegra = false;
			$scope.bAviso = false;

			$scope.publicEmail = true;

			if (type === 'INTEGRA') {
				if ($scope.idRegraAcaoEvento !== -23) {
					$scope.idRegraAcaoEvento = -23;
					params.push({
						ativo: true,
						idRegraAcaoEvento: -23,
						idCliente: $scope.userData.idCliente
					});
					params.push({
						ativo: false,
						idRegraAcaoEvento: -1,
						idCliente: $scope.userData.idCliente
					});
					updateNotificationAction(params);
				}

				$scope.publicEmailOption = type;

				$scope.bIntegra = true;
				$scope.bAviso = false;
			} else {
				if ($scope.idRegraAcaoEvento !== -1) {
					$scope.idRegraAcaoEvento = -1;
					params.push({
						ativo: false,
						idRegraAcaoEvento: -23,
						idCliente: $scope.userData.idCliente
					});
					params.push({
						ativo: true,
						idRegraAcaoEvento: -1,
						idCliente: $scope.userData.idCliente
					});
					updateNotificationAction(params);

					$scope.publicEmailOption = type;
				}
				$scope.bIntegra = false;
				$scope.bAviso = true;
			}

			setTimeout(() => {
				$scope.updateRadiosOptions();
			}, 50);
		};

		$scope.setNotificationProcess = type => {
			let params = [];

			$scope.procEmail = true;

			if (type === 'PROCCESS_NEW') {
				if ($scope.idRegraAcaoEvento !== -31) {
					$scope.idRegraAcaoEvento = -31;
					params.push({
						ativo: true,
						idRegraAcaoEvento: -31,
						idCliente: $scope.userData.idCliente
					});
					params.push({
						ativo: false,
						idRegraAcaoEvento: -3,
						idCliente: $scope.userData.idCliente
					});
					updateNotificationAction(params);
				}

				$scope.procEmailOption = 'PROCCESS_NEW';
			} else {
				if ($scope.idRegraAcaoEvento !== -3) {
					$scope.idRegraAcaoEvento = -3;
					params.push({
						ativo: false,
						idRegraAcaoEvento: -31,
						idCliente: $scope.userData.idCliente
					});
					params.push({
						ativo: true,
						idRegraAcaoEvento: -3,
						idCliente: $scope.userData.idCliente
					});
					updateNotificationAction(params);
				}
				$scope.procEmailOption = 'PROCCESS_QUANTIDADE';
			}

			setTimeout(() => {
				$scope.updateRadiosOptions();
			}, 100);
		};

		$scope.loadCheckedOption = () => {
			let params = {
				...helper.httpFields(['*']),
				IdsRegraAcaoEvento: '-1,-23,-24,-3,-31,-25,-37,-38,-39',
				ativo: true
			};

			if ($scope.groupSelect != 'true') {
				params.idCliente = $scope.userData.idCliente;
				params.idUsuarioCliente = $scope.userData.idUsuarioCliente;
			} else {
				params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.actionEventClientUser, 'GET'),
				params: params
			}).then(({ data }) => {
				const ids = data.itens.length
					? data.itens.map(item => item.idRegraAcaoEvento)
					: null;

				if (data.itens.length) {
					if (ids && (ids.includes(-1) || ids.includes(-23))) {
						$scope.publicEmail = true;

						if (ids.includes(-1)) {
							$scope.publicEmailOption = 'QUANTIDADE';
						} else if (ids.includes(-23)) {
							$scope.publicEmailOption = 'INTEGRA';
						}

						document.getElementById('send-mov-notification').checked = true;
					} else {
						document.getElementById('send-mov-notification').checked = false;
					}

					if (ids.includes(-24) || ids.includes(-25)) {
						$scope.sendNotNotification = true;
						$scope.notPublicEmail = true;

						if (ids.includes(-24)) {
							$scope.notPublicEmailOption = -24;
						} else if (ids.includes(-25)) {
							$scope.notPublicEmailOption = -25;
						}

						document.getElementById('send-mov-not-notification').checked = true;
					} else {
						document.getElementById(
							'send-mov-not-notification'
						).checked = false;
					}

					if (ids && (ids.includes(-3) || ids.includes(-31))) {
						$scope.procEmail = true;

						if (ids.includes(-3)) {
							$scope.procEmailOption = 'PROCCESS_QUANTIDADE';
						} else if (ids.includes(-31)) {
							$scope.procEmailOption = 'PROCCESS_NEW';
						}

						document.getElementById(
							'send-mov-proc-notification'
						).checked = true;
					} else {
						document.getElementById(
							'send-mov-proc-notification'
						).checked = false;
					}

					if (ids && ids.includes(-39)) {
						$scope.notIntimacoesEmail = true;

						document.getElementById(
							'send-not-intimacoes-notification'
						).checked = true;
					} else {
						document.getElementById(
							'send-not-intimacoes-notification'
						).checked = false;
					}

					if (ids && (ids.includes(-37) || ids.includes(-38))) {
						$scope.intimacoesEmail = true;

						if (ids.includes(-37)) {
							$scope.intimacoesEmailOption = 'INTIMACOES_QUANTIDADE';
						} else if (ids.includes(-38)) {
							$scope.intimacoesEmailOption = 'INTIMACOES_INTEGRA';
						}

						document.getElementById(
							'send-intimacoes-notification'
						).checked = true;
					} else {
						document.getElementById(
							'send-intimacoes-notification'
						).checked = false;
					}

					setTimeout(() => {
						$scope.updateRadiosOptions();
					}, 5);
				} else {
					document.getElementById('send-mov-notification').checked = false;
					document.getElementById('send-mov-not-notification').checked = false;
					document.getElementById('send-mov-proc-notification').checked = false;
					document.getElementById(
						'send-not-intimacoes-notification'
					).checked = false;
				}
			});
		};

		setTimeout(() => {
			$scope.loadCheckedOption();
		}, 50);

		const GETCLIENTUSERS = [];

		$scope.groups = helper
			.responseStore()
			.setLoading()
			.setCurrentPage($stateParams.paginaAtual || 1)
			.setItemsPerPage(20);

		$scope.hasGroupPermission = JSON.parse(
			localStorage.getItem('_allowedGroup_')
		);

		let data = JSON.parse(localStorage.getItem('__authenticationUserData__'));

		$scope.isUserAdmin = JSON.parse(data.flUsuarioAdministrador);

		$scope.groups.__paginacao = {};

		$scope.groupCreate = helper.responseStore();

		$scope.groupEdit = helper.responseStore();

		$scope.clientUsers = helper.responseStore().setLoading();

		$scope.listUsersClient = helper.responseStore();

		$scope.printing = false;

		$scope.recordGroups = response => {
			if (response && $scope.currentPage) {
				response.paginaAtual = $scope.currentPage;
			}

			$scope.loadingRecordGroups = true;
			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(res => {
				if (res.data.itens.length) {
					$scope.idQtdItensPagina = res.data.itens[0].idParamUsuarioProdAdv;
					$scope.groups.setItemsPerPage(
						res.data.itens[0].qtdRegistroMovPorPagina
							? res.data.itens[0].qtdRegistroMovPorPagina
							: 20
					);
				}

				if (response) {
					var page = response.paginaAtual;
				} else {
					var page = $scope.groups.getCurrentPage();
				}

				$http({
					...helper.http(API.groupUsers, 'GET'),
					params: {
						...helper.httpFields(['*']),
						IdsSituacaoGrupoUsuario: [-1, -2],
						paginaAtual: page,
						registrosPorPagina: $scope.groups.getItemsPerPage()
					}
				})
					.then(response => {
						$scope.groupsLength = response.data.paginacao.registrosTotal || 0;
						$scope.groupsPageLength = response.data.paginacao.paginaTotal || 0;
						$scope.groups.__paginacao = response.data.paginacao;
						response.data.itens.forEach(grupo => {
							grupo.listaUsuario = grupo.listaUsuariosGrupo
								.map(usuario => usuario.nomeUsuario)
								.join(',');
						});
						$scope.groups.setItems(response.data.itens);
						$scope.groups.setNotLoading();

						let idUserClient = null;

						try {
							idUserClient =
								JSON.parse(localStorage.getItem('__authenticationUserData__'))
									.idUsuarioCliente || null;
						} catch (_) {
							/* ignora erro de JSON */
						}

						const hasGroup = ($scope.groups.getItems() || []).some(group =>
							(group.listaUsuariosGrupo || []).some(
								user =>
									user.idUsuarioCliente == idUserClient && user.ativo === true
							)
						);

						$rootScope.haveGroup = hasGroup;
						localStorage.setItem('__hasGroup__', JSON.stringify(hasGroup));
					})
					.finally(() => ($scope.loadingRecordGroups = false));
			});
		};

		if ($scope.hasGroupPermission) $scope.recordGroups();

		$scope.updateQuantityPerPage = async quantityPerPage => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			$scope.idQtdItensPagina = $scope.idQtdItensPagina
				? $scope.idQtdItensPagina
				: record.idParamUsuarioProdAdv;

			let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

			$scope.quantityPerPage = quantityPerPage;

			await $http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [
						{
							id: record.idParamUsuarioProdAdv,
							qtdRegistroMovPorPagina: quantityPerPage || 20
						}
					]
				},
				messageOverride: {
					success() {}
				}
			}).then(() => {
				record.qtdRegistroMovPorPagina = quantityPerPage || 20;

				sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

				var params = {
					paginaAtual: 1
				};

				$scope.currentPage = 1;

				$scope.recordGroups(params);
			});
		};

		$scope.recordClientUsers = () => {
			$http({
				...helper.http(API.usersCustomers, 'GET'),
				params: {
					...helper.httpFields(['id', 'ativoUsuario', 'pessoa.nome']),
					IdCliente: authentication.getUserData('idCliente')
				}
			}).then(response => {
				GETCLIENTUSERS.push(response.data.itens);
				$scope.clientUsers.setItems(response.data.itens);
				$scope.clientUsers.setNotLoading();
			});
		};

		$scope.recordClientUsers();

		//Filtro somentes usuarios ativos para cadastrar em grupo
		$scope.filterAtivo = value => value.ativoUsuario;

		//Função pra adicionar os clientes do select pra listagem e remove eles do select (modal de criar grupo)
		$scope.addUserClient = userClient => {
			if (userClient == undefined) return;
			let userSelected = $scope.clientUsers
				.getItems()
				.filter(item => item.id == userClient)[0];

			userSelected.administrador = false;

			$scope.listUsersClient.items.push(userSelected);

			$scope.clientUsers.getItems().splice(
				$scope.clientUsers
					.getItems()
					.map(x => x.id)
					.indexOf(Number(userClient)),
				1
			);
		};

		$scope.deleteAddUser = (user, index, userGroupList, userAddList) => {
			userAddList.push(user);
			userGroupList.splice(index, 1);
		};

		$scope.createGroupStep1 = responseStore => {
			let inputGroupName = document.getElementById('inputGroupName');

			if (!inputGroupName.value.trim()) {
				inputGroupName.focus();

				return;
			}

			$scope.printing = true;

			$http({
				...helper.http(API.groupUsers, 'POST'),
				data: {
					itens: [
						{
							nomeGrupo: responseStore.nomeGrupo,
							idSituacaoGrupo: -1
						}
					]
				},
				messageOverride: {
					success(res, notify) {
						notify.success(
							'Grupo criado! Adicione os usuários e defina administradores para finalizar o cadastro do grupo.'
						);
					}
				}
			})
				.then(response => {
					var authenticationUserData = JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					);

					let newGroup = {
						dataHoraInclusao: new Date().toISOString(),
						idCliente: authenticationUserData.idCliente,
						idGrupo: response.data.itens[0].id,
						idSituacaoGrupo: -2,
						listaUsuario: '',
						listaUsuariosGrupo: [],
						nomeCliente: authenticationUserData.nome,
						nomeGrupo: responseStore.nomeGrupo,
						nomeUsuarioInclusao: authenticationUserData.nome,
						situacaoGrupo: 'Inativo'
					};

					$scope.groups.getItems().unshift(newGroup);

					if (
						$scope.groups.getItemsPerPage() <= $scope.groups.getItems().length
					) {
						$scope.groups.getItems().splice($scope.groups.getItemsPerPage(), 1);
					}

					$scope.groupsLength += 1;

					$('#modalCreateGroupStep1').modal('hide');
					$('#modalCreateGroupStep1 input').val('');
					responseStore.setItems(response.data.itens);
					$('#modalCreateGroupStep2').modal('show');
				})
				.finally(() => {
					$scope.printing = false;

					$scope.recordGroups();
				});
		};

		$scope.createGroupStep2 = (responseStore, idGroup) => {
			$scope.printing = true;

			let itens = [];

			responseStore.getItems().forEach(item => {
				itens.push({
					idUsuarioCliente: item.id,
					idGrupo: idGroup,
					administrador: item.administrador ? item.administrador : false
				});
			});

			$http({
				...helper.http(API.groupXUsers, 'POST'),
				data: {
					itens: itens
				}
			})
				.then(() => {
					$('#modalCreateGroupStep2').modal('hide');

					$scope.recordGroups();
					$state.go($state.current.name);

					setTimeout(() => {
						$('#modalSucess').modal('show');
					}, 200);
				})
				.finally(() => {
					$scope.listUsersClient.items = [];
					$scope.recordClientUsers();
					$scope.printing = false;
				});
		};

		$scope.refreshSearch = () => {
			$('#modalSucess').modal('hide');
		};

		$scope.adminPermission = () => {
			if (!$scope.hasGroupPermission || !$scope.isUserAdmin) {
				let modal = $('#modalNotPermitted');

				modal.modal('show');

				return true;
			}
		};

		$scope.openToggleStatusModal = item => {
			//metedo que verifica de usuario tem permissão pra cadastrar, editar, excluir grupos
			let notAdmin = $scope.adminPermission();

			if (notAdmin) return;

			$scope.toggleElement = item;

			$('#modalToggleStatusGroup').modal('show');
		};

		$scope.openCreateModal = () => {
			//metedo que verifica de usuario tem permissão pra cadastrar, editar, excluir grupos
			let notAdmin = $scope.adminPermission();

			if (notAdmin) return;

			let inputGroupName = document.getElementById('inputGroupName');
			let groupForm = document.getElementById('groupForm');

			if (inputGroupName) {
				inputGroupName.className =
					'form-control-sm ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched';
				inputGroupName.classList.add('form-control');
				inputGroupName.value = '';
			}
			if (groupForm) {
				groupForm.className = '';
				groupForm.classList.add('form-group');
			}

			$('#modalCreateGroupStep1').on('shown.bs.modal', () => {
				document.getElementById('inputGroupName').focus();
			});
			$('#modalCreateGroupStep1').modal('show');
		};

		$scope.openDeleteModal = item => {
			$scope.deleteElement = item;

			setTimeout(() => {
				$('#modalDeleteGroup').modal('show');
			}, 250);
		};

		$scope.inactiveGroup = item => {
			let selectGroup = JSON.parse(
				localStorage.getItem('__groupSelected__') || null
			);
			let group = JSON.parse(localStorage.getItem('__groupUserData__') || null);

			if (selectGroup && group && group.idGrupo === item.idGrupo) {
				notification.danger(
					'Não é possível inativar o grupo em que você está logado.'
				);

				$('#modalToggleStatusGroup').modal('hide');

				return false;
			}

			$scope.printing = true;

			$http({
				...helper.http(API.groupUsers, 'alterarSituacao'),
				method: 'PUT',
				data: {
					itens: [
						{
							idGrupo: item.idGrupo,
							idSituacaoGrupo: item.idSituacaoGrupo == -1 ? -2 : -1
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success(
							`Grupo foi ${
								item.idSituacaoGrupo == -1 ? 'inativado' : 'ativado'
							} com sucesso!`
						);
					}
				}
			})
				.then(({ data }) => {
					$('#modalToggleStatusGroup').modal('hide');

					$scope.groups.getItems().map(grupo => {
						if (grupo.idGrupo == item.idGrupo) {
							grupo.idSituacaoGrupo = item.idSituacaoGrupo == -1 ? -2 : -1;
							grupo.situacaoGrupo =
								grupo.idSituacaoGrupo == -1 ? 'Ativo' : 'Inativo';

							grupo.listaUsuariosGrupo = data.itens[0].listaUsuariosGrupo;
						}
					});

					let idUserClient = null;

					try {
						idUserClient =
							JSON.parse(localStorage.getItem('__authenticationUserData__'))
								.idUsuarioCliente || null;
					} catch (_) {
						/* ignora erro de JSON */
					}

					const hasGroup = ($scope.groups.getItems() || []).some(group =>
						(group.listaUsuariosGrupo || []).some(
							user =>
								user.idUsuarioCliente == idUserClient && user.ativo === true
						)
					);

					$rootScope.haveGroup = hasGroup;
					localStorage.setItem('__hasGroup__', JSON.stringify(hasGroup));

					$state.go($state.current.name);
				})
				.finally(() => {
					$scope.printing = false;
				});
		};

		$scope.deleteGroup = item => {
			$scope.printing = true;

			$http({
				...helper.http(API.groupUsers, 'alterarSituacao'),
				method: 'PUT',
				data: {
					itens: [
						{
							idGrupo: item.idGrupo,
							idSituacaoGrupo: -3
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Grupo foi excluido com sucesso!');
					}
				}
			})
				.then(() => {
					$('#modalDeleteGroup').modal('hide');

					$scope.groups.getItems().map((grupo, index) => {
						if (grupo.idGrupo == item.idGrupo) {
							$scope.groups.getItems().splice(index, 1);
						}
					});

					$rootScope.haveGroup = $scope.groups
						? $scope.groups
								.getItems()
								.some(grupo => grupo.situacaoGrupo === 'Ativo')
						: false;

					localStorage.setItem('__hasGroup__', $rootScope.haveGroup);

					$state.go($state.current.name);
				})
				.finally(() => {
					$scope.printing = false;

					$scope.recordGroups();
				});
		};

		$scope.toggleAdmin = user => {
			let clientId = user.idUsuario;

			if (user.idUsuarioCliente) clientId = user.idUsuarioCliente;

			$scope.groupEdit.usuariosGrupo[0].map(usuario => {
				if (usuario.idUsuarioCliente) {
					if (usuario.idUsuarioCliente == clientId)
						usuario.administrador = !usuario.administrador;
				} else {
					if (usuario.idUsuario == clientId)
						usuario.administrador = !usuario.administrador;
				}
			});
		};

		$scope.toggleAddAdmin = user => {
			user.administrador = user.administrador ? !user.administrador : true;
		};

		$scope.openToggleEditGroupModal = item => {
			//metedo que verifica de usuario tem permissão pra cadastrar, editar, excluir grupos
			let notAdmin = $scope.adminPermission();

			if (notAdmin) return;

			$scope.printing = true;

			$scope.groupEdit = {
				nomeGrupo: '',
				idGrupo: item.idGrupo,
				usuariosGrupo: []
			};
			$http({
				...helper.http(API.groupUsers, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idsGrupoUsuarios: [item.idGrupo]
				}
			})
				.then(response => {
					$scope.groupEdit.nomeGrupo = response.data.itens[0].nomeGrupo;
					//Usuários já adicionados no grupo
					$scope.groupEdit.usuariosGrupo.push(
						response.data.itens[0].listaUsuariosGrupo
					);
					//Usuários para serem adicionados no grupo (select)
					$scope.usersClientEdit = helper.cloneSimpleObject(GETCLIENTUSERS);

					const idsUsuariosGrupo = $scope.groupEdit.usuariosGrupo[0].map(
						item => item.idUsuarioCliente
					);

					$scope.newArray = [];

					$scope.usersClientEdit[0].map(client => {
						//Verifica se o cliente está no grupo
						let clientIndex = idsUsuariosGrupo.indexOf(client.id);

						//Se não tiver, coloca na lista
						if (clientIndex < 0 && client.ativoUsuario) {
							$scope.newArray.push(client);
						} else {
							//Se tiver e estiver inativo, coloca na lista
							let userGroup = $scope.groupEdit.usuariosGrupo[0][clientIndex];

							if (userGroup && !userGroup.ativo) $scope.newArray.push(client);
						}
					});
				})
				.finally(() => {
					$('#modalEditGroup').modal('show');
					$scope.printing = false;
				});
		};

		//Função pra adicionar os clientes do select pra listagem e remove eles do select (modal de editar grupo)
		$scope.addUserClientToList = (userClient, idGroup) => {
			if (userClient == undefined) return;

			let alreadyUser = $scope.groupEdit.usuariosGrupo[0].filter(
				usuario => usuario.idUsuarioCliente == userClient && !usuario.ativo
			);

			if (alreadyUser.length > 0) {
				alreadyUser[0].ativo = true;
			} else {
				let userSelected = $scope.newArray.filter(
					item => item.id == userClient
				)[0];

				if (userSelected) {
					$scope.groupEdit.usuariosGrupo[0].push({
						idGrupo: idGroup,
						idUsuario: userSelected.id,
						nomeUsuario: userSelected.pessoa.nome,
						administrador: false,
						ativo: true
					});
				} else {
					$scope.groupEdit.usuariosGrupo[0].push(userClient);
				}
			}

			$scope.newArray.splice(
				$scope.newArray.map(x => x.id).indexOf(Number(userClient)),
				1
			);
		};

		$scope.editGroup = group => {
			$scope.printing = true;

			let itensGroup = [
				{
					nomeGrupo: group.nomeGrupo,
					idGrupo: group.idGrupo
				}
			];

			let groupUsers = [];

			let newUsers = [];

			group.usuariosGrupo[0].forEach(item => {
				let administrador = item.administrador ? item.administrador : false;

				if (item.idUsuarioXGrupo) {
					groupUsers.push({
						idUsuarioXGrupo: item.idUsuarioXGrupo,
						administrador: item.administrador,
						ativo: item.ativo
					});
				} else {
					newUsers.push({
						idUsuarioCliente: item.idUsuario,
						administrador: administrador,
						idGrupo: group.idGrupo
					});
				}
			});

			$http({
				...helper.http(API.groupUsers, 'PUT'),
				data: {
					itens: itensGroup
				},
				messageOverride: {
					success() {},
					error() {}
				}
			})
				.then(() => {
					if (groupUsers.length > 0) {
						$http({
							...helper.http(API.groupXUsers, 'PUT'),
							data: {
								itens: groupUsers
							},
							messageOverride: {
								success() {},
								error() {}
							}
						});
					}

					if (newUsers.length > 0) {
						$http({
							...helper.http(API.groupXUsers, 'POST'),
							data: {
								itens: newUsers
							},
							messageOverride: {
								success() {},
								error() {}
							}
						});
					}

					$scope.groups.getItems().map(grupo => {
						if (grupo.idGrupo == group.idGrupo) {
							grupo.nomeGrupo = group.nomeGrupo;

							if (
								$scope.getActiveUsers(grupo).length == 0 &&
								group.usuariosGrupo[0].length > 0
							) {
								grupo.idSituacaoGrupo = -1;
								grupo.situacaoGrupo = 'Ativo';
							}

							grupo.listaUsuariosGrupo = group.usuariosGrupo[0];
							if ($scope.getActiveUsers(grupo).length == 0) {
								grupo.idSituacaoGrupo = -2;
								grupo.situacaoGrupo = 'Inativo';
							} else if ($scope.getActiveUsers(grupo).length == 1) {
								grupo.listaUsuariosGrupo[0].administrador = true;
							}

							if (
								$scope.getActiveUsers(grupo).filter(user => user.administrador)
									.length == 0
							)
								grupo.listaUsuariosGrupo[0].administrador = true;
						}
					});

					$('#modalEditGroup').modal('hide');
					notification.success('Grupo editado com sucesso!');
				})
				.finally(() => {
					$scope.printing = false;
				});
		};

		$scope.deleteUser = (user, index, userGroupList, userAddList) => {
			if (user.idUsuarioCliente) user.id = user.idUsuarioCliente;

			if (user.idUsuario) user.id = user.idUsuario;

			let clientId = user.id;

			let clients = helper.cloneSimpleObject(GETCLIENTUSERS);

			clients[0].map(client => {
				if (client.id == clientId) userAddList.push(client);
			});

			if (user.idUsuarioCliente) user.ativo = false;
			else userGroupList.splice(index, 1);
		};

		$scope.clearGroupForm = () => {
			$scope.groupCreate.nomeGrupo = '';

			$scope.listUsersClient.items = [];

			$scope.recordClientUsers();
		};

		$scope.getActiveUsers = group => {
			return group.listaUsuariosGrupo.filter(user => user.ativo);
		};

		/************* Paginação *************/

		$scope.getCurrentPageNumber = () => {
			const currentPage = parseInt($stateParams.paginaAtual, 10);

			return Number.isNaN(currentPage) ? 1 : currentPage;
		};

		$scope.hasPrevPage = () => $scope.getCurrentPageNumber() > 1;

		$scope.recordGroupsPaginate = direction => {
			let params = helper.cloneSimpleObject($stateParams);

			if (direction == 'nextPage')
				$scope.currentPage = $scope.currentPage ? $scope.currentPage + 1 : 2;
			else if (direction == 'firstPage') $scope.currentPage = 1;
			else if (!isNaN(direction)) $scope.currentPage = direction;
			else $scope.currentPage = $scope.currentPage ? $scope.currentPage - 1 : 1;

			$scope.recordGroups(params);
		};

		$scope.sync = false;
		$scope.dataSync = null;
		$scope.recoveryDeadlines = false;

		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!$scope.dataSync)
				await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError =
				$scope.dataSync && !!$scope.dataSync.error;

			if ($scope.dataSync && $scope.dataSync.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = $scope.dataSync.email;
				$scope.sync = true;
			} else {
				$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
					? true
					: false;
				$rootScope.emailGoogle = false;
			}

			if ($rootScope.sincronizacaoError)
				$('#modalDisabledGoogleCalendarError').modal('show');
		};

		$scope.recordIntegration();
		integracaoGoogleCalendar.ensureGoogleIdentityLoaded().catch(() => {});

		$rootScope.sync =
			$rootScope.sync === undefined ? $scope.sync : $rootScope.sync;

		$('#modalDisabledGoogleCalendar').on('hidden.bs.modal', function() {
			if (!$rootScope.sync) {
				$('#inputGoogleCalendarModal').prop('checked', false);
			} else {
				$('#inputGoogleCalendarModal').prop('checked', true);
			}
		});

		$('#modalRecoverPastDeadlines').on('hidden.bs.modal', function() {
			if (!$rootScope.sync) {
				$('#inputGoogleCalendarModal').prop('checked', false);
			} else {
				$('#inputGoogleCalendarModal').prop('checked', true);
			}
		});

		$scope.closeModal = id => {
			$(`#${id}`).modal('hide');
		};

		$scope.recoverPastDeadlines = async () => {
			$rootScope.syncSuccess = true;
			$scope.openGoogleCalendarFromConfigConfirmation();
		};

		$scope.noRecoverPastDeadlines = async () => {
			$rootScope.syncSuccess = false;
			$scope.openGoogleCalendarFromConfigConfirmation();
		};

		$scope.openGoogleCalendarFromConfigConfirmation = async () => {
			$('#modalRecoverPastDeadlines').modal('hide');

			try {
				await integracaoGoogleCalendar.initCodeClient();
			} catch (error) {
				$rootScope.sync = false;
			}
		};

		$scope.openGoogleCalendarModalAfterRecoverPastDeadlinesCloses = () => {
			const modalRecoverPastDeadlines = $('#modalRecoverPastDeadlines');
			const modalRecoverPastDeadlinesIsOpen =
				modalRecoverPastDeadlines.hasClass('show') ||
				modalRecoverPastDeadlines.hasClass('in') ||
				modalRecoverPastDeadlines.is(':visible');
			let googleCalendarOpened = false;

			const openGoogleCalendar = () => {
				if (googleCalendarOpened) {
					return;
				}

				googleCalendarOpened = true;
				$scope.openGooogleCalendarModal(true);
			};

			if (!modalRecoverPastDeadlinesIsOpen) {
				openGoogleCalendar();

				return;
			}

			modalRecoverPastDeadlines.one('hidden.bs.modal', function() {
				$timeout(openGoogleCalendar, 100);
			});
			modalRecoverPastDeadlines.modal('hide');
			$timeout(openGoogleCalendar, 400);
		};

		$scope.openRecoverPastDeadlines = async () => {
			$("input[id='inputGoogleCalendarModal']").prop(
				'checked',
				$rootScope.emailGoogleAccount
			);

			await $scope.recordIntegration();
			await integracaoGoogleCalendar.ensureGoogleIdentityLoaded().catch(() => {});

			if ($scope.groupSelected === 'true') {
				$rootScope.syncSuccess = true;
				$scope.openGooogleCalendarModal();
			} else {
				const isSynced =
					$scope.dataSync && $scope.dataSync.sincronizado && !$rootScope.sincronizacaoError;

				if (isSynced) {
					$('#modalDisabledGoogleCalendar').modal('show');
				} else {
					$('#modalRecoverPastDeadlines').modal('show');
				}
			}
		};

		$scope.openGooogleCalendarModal = async skipRecoverPastDeadlinesCheck => {
			const modalRecoverPastDeadlines = $('#modalRecoverPastDeadlines');
			const modalRecoverPastDeadlinesIsOpen =
				modalRecoverPastDeadlines.hasClass('show') ||
				modalRecoverPastDeadlines.hasClass('in') ||
				modalRecoverPastDeadlines.is(':visible');

			if (modalRecoverPastDeadlinesIsOpen && !skipRecoverPastDeadlinesCheck) {
				$scope.openGoogleCalendarModalAfterRecoverPastDeadlinesCloses();

				return;
			}

			if (!$rootScope.sincronizacaoError) await $scope.recordIntegration();

			$rootScope.sync = $scope.dataSync ? $scope.dataSync.sincronizado : false;

			if (!$rootScope.sync && !$rootScope.sincronizacaoError) {
				try {
					await integracaoGoogleCalendar.initCodeClient();
				} catch (error) {
					$rootScope.sync = false;
				}
			} else {
				$('#modalDisabledGoogleCalendar').modal('show');
			}
		};

		$scope.disabledGoogleCalendar = async () => {
			$scope.printing = true;
			$scope.unsynClicked = true;
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				$scope.dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendar').modal('hide');

			$rootScope.sync = false;
			$rootScope.emailGoogleAccount = false;

			$scope.printing = false;
		};

		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				$scope.dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');
			$scope.unsynClicked = true;

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			$scope.openGooogleCalendarModal();
		};

		$scope.redirectNotificacoes = () => {
			$scope.currentTab = 'nav-notificacoes';

			setTimeout(() => {
				if ($scope.publicEmail) {
					document.getElementById('send-mov-notification').checked = true;
				} else {
					document.getElementById('send-mov-notification').checked = false;
				}

				if ($scope.notPublicEmail) {
					document.getElementById('send-mov-not-notification').checked = true;
				} else {
					document.getElementById('send-mov-not-notification').checked = false;
				}

				if ($scope.procEmail) {
					document.getElementById('send-mov-proc-notification').checked = true;
				} else {
					document.getElementById('send-mov-proc-notification').checked = false;
				}

				if ($scope.notIntimacoesEmail) {
					document.getElementById(
						'send-not-intimacoes-notification'
					).checked = true;
				} else {
					document.getElementById(
						'send-not-intimacoes-notification'
					).checked = false;
				}

				if ($scope.intimacoesEmail) {
					document.getElementById(
						'send-intimacoes-notification'
					).checked = true;
				} else {
					document.getElementById(
						'send-intimacoes-notification'
					).checked = false;
				}
			}, 5);
		};

		$scope.focusInputCreateEmail = () => {
			$timeout(() => {
				document.getElementById('inputCreateEmail').focus();
			}, 500);
		};
	}
]);

export default controller;
